import { render, staticRenderFns } from "./SearchShippingLeadTimeViewDetailsDialogAdditionalShippingLeadTime.vue?vue&type=template&id=4dd22ea2&scoped=true&"
import script from "./SearchShippingLeadTimeViewDetailsDialogAdditionalShippingLeadTime.vue?vue&type=script&lang=js&"
export * from "./SearchShippingLeadTimeViewDetailsDialogAdditionalShippingLeadTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd22ea2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VDivider,VRow,VTooltip})
